import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {bbDangerousStringToDate, bbFormattedDateString, isCurrentUserMemberOf} from "../../../../../util/bbHelpers";
import {
    activatePentestingForEntity, activateSocialTestingForEntity,
    deactivatePentestingForEntity, deactivateSocialTestingForEntity,
    fetchAllEntities,
    unverifyPrimaryDomain,
    verifyPrimaryDomain
} from "../../../../../actions";
import {renderCellExpand} from "../../../../../components/customBreachBits/tables/DataGridRenderCellExpand";
import BBDataTable from "../../../../../components/customBreachBits/tables/BBDataTable";
import SVGCircleFilledIn from "../../../../../components/customBreachBits/accents/SVGCircleFilledIn";
import {
    BRCustomizedTooltip,
    BRCustomizedTooltip as Tooltip
} from "../../../../../components/customBreachBits/accents/BRCustomizedTooltip";
import {Badge, Col, Row} from "reactstrap";
import BBIconRoundedDashNull from "../../../../../assets/bbCustomIcons/BBIconRoundedDashNull";
import Switch from "@material-ui/core/Switch";
import {CircularProgress, IconButton} from "@mui/material";
import UpdateEntityMenu from "../../../../../components/customBreachBits/modals/UpdateEntityMenu";
import BBIconCheck from "../../../../../assets/bbCustomIcons/BBIconCheck";
import ExpandedEntityInformationPanel
    from "../../../../../components/customBreachBits/modals/ExpandedEntityInformationPanel";
import {
    DataGridPro,
    GridToolbarColumnsButton,
    GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport,
    GridToolbarFilterButton
} from "@mui/x-data-grid-pro";
import {LinearProgress} from "@material-ui/core";

const AllEntitiesPage = ({props}) =>{

    const {customers, loadingCustomers, } = useSelector(({customer}) => customer);
    const { entitiesList, loadingEntitiesList, loadingEntitiesError, loadingUpdateEntityPenTesting, loadingUpdateEntityPenTestingError,
            loadingUpdateEntitySocialTesting, loadingUpdateEntitySocialTestingError, loadingVerifyPrimaryDomain, loadingVerifyPrimaryDomainError} = useSelector(({admin})=> admin);
    const authUser = useSelector(({auth}) => auth.authUser);

    const isAdminStaff = isCurrentUserMemberOf(authUser, "admin") || isCurrentUserMemberOf(authUser, "staff");

    const dispatch = useDispatch();

    useEffect(()=>{
        if(isAdminStaff){
            let pageNumberToFetch = null;
            if(!entitiesList
                && !loadingEntitiesError
                && !loadingEntitiesList){
                pageNumberToFetch = 1;
            } else if(
                loadingEntitiesList
                && loadingEntitiesList.page
                && loadingEntitiesList.nextPageRequest
            ){
                pageNumberToFetch = loadingEntitiesList.nextPageRequest
            }else{
                console.warn("Something went wrong, FETCH_ALL_ENTITIES")
            }

            if(pageNumberToFetch && !loadingEntitiesError){
                console.log("FETCHING ENTIESI PAGE", pageNumberToFetch)
                dispatch(fetchAllEntities(pageNumberToFetch));
            }
        }
    },[entitiesList, loadingEntitiesList, loadingEntitiesError])


    const verifyDomain = (entityInView, domainId, newStatus)=>{
        if(!loadingVerifyPrimaryDomain[entityInView]
        && !loadingVerifyPrimaryDomainError[entityInView]){
            if(newStatus){
                dispatch(verifyPrimaryDomain(entityInView, domainId));
            }else{
                dispatch(unverifyPrimaryDomain(entityInView, domainId))
            }
            console.log("dispatching verifyPrimaryDomain action, sending data: entityInView:", entityInView, "domainId", domainId);
        }else{
            console.warn("Some error occurred with loading or updating the domain verification.")
        }
    };

    const handleActiveTestingSwitch = (entityId, currentStatus)=>{
        if(!loadingUpdateEntityPenTesting[entityId]
        && !loadingUpdateEntityPenTestingError[entityId]){
            if(currentStatus){
                console.log("current status for pen testing is true, dispatching deactivation")
                dispatch(deactivatePentestingForEntity(entityId));
            }else{
                console.log("current status for pen testing is false, dispatching activation")

                dispatch(activatePentestingForEntity(entityId))
            }
        } else{
            console.warn("Unable to update entity penetration testing status")
        }

    };


    function DetailPanelContent({row}){
        return(
            <div className={"text-center"} style={{width:"250", height: "100%", backgroundColor: "whitesmoke"}}>
                <Row>
                    <Col>
                        <h2 className={"d-inline"}>{row.name}</h2>
                        {row.added_datetime ?
                            <p className={"float-right d-inline m-0 p-0"}>
                                <strong>Added On: </strong>
                                {bbFormattedDateString(row.added_datetime, "short")}
                            </p>
                            : null}
                    </Col>
                </Row>

                <hr/>
                <Row >
                    <Col>
                        <p><strong>Current Cycle Finished:</strong> {bbFormattedDateString(row.ongoingCycleCompleteDate, "short")}</p>
                    </Col>
                    <Col>
                        <p><strong>Next Cycle: </strong>{bbFormattedDateString(row.nextCycleDateTime, "short")}</p>
                    </Col>
                    <Col>
                        <p><strong>Last Cycle: </strong>{bbFormattedDateString(row.lastCycleDateTime, "short")}</p>

                    </Col>
                </Row>
                <Row>
                    <Col>
                        <p>
                            <strong>Penetration Testing: </strong> {row.activeTesting ? "Yes " : "No"}
                        </p>
                    </Col>
                    <Col>
                        <p>
                            <strong>Social Testing: </strong> {row.socialTesting ? "Yes" : "No"}
                        </p>
                    </Col>
                    <Col>
                        <p>
                            <strong>Testing Periodicity: </strong> {row.settings.periodicity ? row.settings.periodicity : 0} days
                        </p>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <p>
                            <strong>Total Assessments: </strong> {row.settings.total_assessments ? row.settings.total_assessments : "None"}
                        </p>
                    </Col>
                    <Col>
                        <p>
                            <strong>Size of infrastructure: </strong> {row.settings.size ? row.settings.total_assessments : "None"}

                        </p>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <p>
                            <strong> Active Subscription: </strong>{row.customer ? "Yes" : "No"}
                        </p>
                    </Col>
                    <Col>
                        <p className={"d-inline"}>
                            <strong>In Another Customer's Portfolio: </strong>{row.inPortfolio ? "Yes" : "No"}
                        </p>
                    </Col>
                    {row.inPortfolio
                        ? <p className={"d-inline"}>
                                <em>
                                    This will have customer name/links to portfolio, when available.
                                </em>
                            </p>
                        :null}
                </Row>
            </div>
        )
    }

    const CustomToolbar = () => {
        return (
            <GridToolbarContainer>

                <GridToolbarColumnsButton/>
                <GridToolbarFilterButton/>
                <GridToolbarDensitySelector/>
                {/*{enableExport &&*/}
                {/*    <GridToolbarExport*/}
                {/*        // printOptions={{disableToolbarButton: true }}*/}
                {/*        csvOptions={{ allColumns: true }}/>*/}
                {/*}*/}
            </GridToolbarContainer>
        );
    }

    const getDetailPanelContent = React.useCallback(({ row }) => <DetailPanelContent row={row} />, []);

    const getDetailPanelHeight = React.useCallback(() => 200, []);

    const handleSocialTestingSwitch = (entityId, currentStatus)=>{
        if(!loadingUpdateEntitySocialTesting[entityId]
        && !loadingUpdateEntitySocialTestingError[entityId]){
            if(currentStatus){
                console.log("current status for social testing is true, dispatching deactivation")
                dispatch(deactivateSocialTestingForEntity(entityId));
            }else{
                console.log("current status for social testing is false, dispatching activation")

                dispatch(activateSocialTestingForEntity(entityId));
            }
        }else{
            console.warn("unable to update entity social testing status")
        }
    };

    const columns =[
    { field: 'name', headerName: 'Name', hide: false, flex:1.25, sortable: true, type: 'string', renderCell:
            (params) => renderCellExpand(params,(<span className={"d-inline"}>
               {/*{params.row.logo_url*/}
               {/*    ? <img style={{height: 30, maxWidth:50, display: "inline"}} src={params.row.logo_url} alt={"logo"} className={"d-inline"}/>*/}
               {/*    : null}&nbsp;*/}
               <p className={"d-inline"}> {params.value}</p>
               {/* <UpdateEntityNameDialog entityId={params.row.id}/>*/}
            </span>))},
        {field: 'customer', headerName: 'Active Subscription', hide: true, width: 40, sortable: true, type: 'string', renderCell:
                (params) => renderCellExpand(params,
                    (params.value
                        ? <BBIconCheck />
                        : <BBIconRoundedDashNull color={'#9A9BAB'}/>)
                )},
    {field: 'cycleOngoing', headerName: 'Ongoing Cycle', hide: true, width: 40, sortable: true, type: 'string', renderCell:
            (params) => renderCellExpand(params,
                (params.value
                    ? <SVGCircleFilledIn />
                    : <SVGCircleFilledIn color={'#9A9BAB'}/>)
            )},
        {field: 'ongoingCycleCompleteDate', headerName: 'Cycle End', hide: false, flex:1, sortable: true, type: 'string', renderCell:
                (params) => renderCellExpand(params,
                    (params.value
                        ? bbFormattedDateString(params.row.ongoingCycleCompleteDate, "shortFullMonth")
                        : null)
                )},
    { field: 'website', headerName: 'website', hide: true, flex:1, sortable: true, type: 'string', renderCell:
            (params) => renderCellExpand(params,(params.value))},
        // { field: 'location', headerName: 'location', hide: true, flex:1, sortable: true, type: 'string', renderCell:
        //         (params) => renderCellExpand(params,(params.value))},
    {field: 'activeTesting', headerName: 'pen testing', hide: false, flex: .5, sortable: true, type: 'boolean',
        renderCell: (params) =>
            renderCellExpand(params,
                (loadingUpdateEntityPenTesting[params.row.id]
                    ? <CircularProgress/>
                :params.row.customer
                                ? <Switch
                        checked={params.value}
                        onChange={()=>handleActiveTestingSwitch(params.row.id, params.value)}
                    />
                            : params.value
                            ?<BRCustomizedTooltip titl={"Subscription is currently false, but pen testing is still set to true"}>
                                    <BBIconCheck className={"text-center"}/>
                </BRCustomizedTooltip>
                                :<BRCustomizedTooltip title={"No subscription, pen testing is not active."}>
                                    <BBIconRoundedDashNull/>
                                </BRCustomizedTooltip>
                ))},
    {field: 'socialTesting', headerName: 'Social Testing', hide: false, flex: .5, sortable: true, type: 'boolean',
        renderCell: (params) =>
            renderCellExpand(params,
                (loadingUpdateEntitySocialTesting[params.row.id]
                        ? <CircularProgress/>
                        :params.row.customer
                            ? <Switch
                                checked={params.value}
                                onChange={()=>handleSocialTestingSwitch(params.row.id, params.value)}
                            />
                            : params.value
                                ?<BRCustomizedTooltip title={"Subscription is currently inactive, but social testing is still set to true"}>
                                    <BBIconCheck className={"text-center"}/>
                                </BRCustomizedTooltip>
                                :<BRCustomizedTooltip title={"No subscription, social testing is not active."}>
                                    <BBIconRoundedDashNull/>
                                </BRCustomizedTooltip>
                ))},
    {field: 'lastCycleDateTime', headerName: 'Last Cycle', hide: false, flex:1, sortable: true, type: 'date', renderCell:
            (params) => renderCellExpand(params,
                (params.value
                    ? bbFormattedDateString(params.value, "shortFullMonth")
                    : "--")
            )},
    {field: 'nextCycleDateTime', headerName: 'Next Cycle', hide: false, flex:1, sortable: true, type: 'date', renderCell:
            (params) => renderCellExpand(params,
                (params.value
                    ? bbFormattedDateString(params.value, "shortFullMonth")
                    : "--")
            )},
    { field: 'isVerified',
        headerName: 'Ownership',
        renderHeader: (params) => <div style={{lineHeight: "normal"}}><Tooltip title={""}>
            <span>Ownership</span>
        </Tooltip></div>,
        hide: !isAdminStaff,
        sortable: true,
        type: 'boolean',
        flex:1,
        renderCell: (params) =>
            renderCellExpand(params, (<>
                    {params.value
                    && !loadingVerifyPrimaryDomain[params.row.id]
                        && !loadingVerifyPrimaryDomainError[params.row.id]
                        ? <Tooltip title={``}>
                                  <span>
                                    <Badge style={{ cursor: "pointer", backgroundColor:"#9A9BAB"}}
                                           onClick={()=>verifyDomain(params.row.id,params.row.primaryDomain.id, false)}>
                                        <small>Remove Verification</small>
                                    </Badge>
                                  </span>
                        </Tooltip>
                        : !params.value
                        && !loadingVerifyPrimaryDomain[params.row.id]
                        && !loadingVerifyPrimaryDomainError[params.row.id]
                            ? <Badge style={{ cursor: "pointer", }}
                                     onClick={()=>verifyDomain(params.row.id,params.row.primaryDomain.id, true)}>
                                <small>Click To Verify</small>
                            </Badge>
                            : loadingVerifyPrimaryDomain[params.row.id]
                            ?<CircularProgress/>
                                :<Tooltip title={``}>
                                  <span>
                                    <BBIconRoundedDashNull/>
                                  </span>
                            </Tooltip>
                    }
                </>

            ))},
        {field: 'inPortfolio', headerName: 'In Portfolio', hide: true, width: 40, sortable: true, type: 'string', renderCell:
                (params) => renderCellExpand(params,
                    (params.value
                        ? <BBIconCheck />
                        : <BBIconRoundedDashNull color={'#9A9BAB'}/>)
                )},
        {
            field: "actions",
            type: "string",
            width: 100,
            exportable: false,
            hide: false,
            renderCell:
                (params) => renderCellExpand(params,
                    (<span>
                            <UpdateEntityMenu entityId={params.row.id}/>
                            {/*<ExpandedEntityInformationPanel entityId={params.row.id}/>*/}
                    </span> )
                )
        }

];

  const tableData = entitiesList ? entitiesList.map((entity)=>{

      const primaryDomain = entity
          && entity.domains
          && Object.values(entity.domains)
              .find((x)=> x.is_primary)

      const isVerified = primaryDomain
          && primaryDomain.verification
          && primaryDomain.verification.verified
      ? primaryDomain.verification.verified
      : false;


      return{
          ...entity,
          activeTesting: entity
              && entity.settings
              && entity.settings.active_testing_authorized,
          //       ? entity.settings.active_testing_authorized
          // : "false",
          activeTestingAuthorized: entity
              && entity.settings
              && entity.settings.active_testing_authorized_by,
          cycleOngoing: entity
              && entity.settings
              && entity.settings.cycle_ongoing,
          ongoingCycleCompleteDate: entity
              && entity.settings
              && entity.settings.ongoing_cycle_complete_datetime
          ? bbDangerousStringToDate(entity.settings.ongoing_cycle_complete_datetime)
              : null,
          lastCycleDateTime: entity
              && entity.settings
              && entity.settings.last_cycle_datetime
          ? bbDangerousStringToDate(entity.settings.last_cycle_datetime)
              : null,
          nextCycleDateTime: entity
          && entity.settings
          && entity.settings.next_cycle_datetime
              ? bbDangerousStringToDate(entity.settings.next_cycle_datetime)
              : null,
          primaryDomain: primaryDomain,
          isVerified: isVerified,
          socialTesting: entity.settings
          && entity.settings.social_testing_authorized,
              // ? entity.settings.social_testing_authorized
              // : "false",
          // location: `${entity.location_city
          //     ? entity.location_city : "--"},
          //     ${entity.location_state
          //     ? entity.location_state: "--"},
          //     ${entity.location_country
          //     ? entity.location_country : "--"}`,
          inPortfolio: entity
          && entity.settings
          && entity.settings.monitored_by
              ? entity.settings.monitored_by > 0
              : false,
      }
  }) : [];

    // console.log("table data for entities", tableData, );

    return(
        // <div className={`animated animated fadeIn animation-duration-7 app-wrapper`}>
        //      {/*style={{ transform: `${ drawerExpanded ? 'translateX(-250px)}' : null}`}}>*/}
        //     {entitiesList &&
        //     <DataGridPro
        //         rows={tableData}
        //         columns={columns}
        //         defaultPageSize={50}
        //         title={"All Entities"}
        //         // loading = {false}
        //         // progressValue={100}
        //         // bufferValue={100}
        //         // getDetailPanelContent={DetailPanelContent()}
        //         autoHeight={true}
        //     />}
        // </div>
        <div className={`animated animated fadeIn animation-duration-7 app-wrapper`} style={{ height: "900px", width: '100%' }}>
            <div className="title">
                <h2 variant="title" className={"arrayTableTitle bb-font-fridge-bold"}>
                    All Entities
                </h2>
            </div>
            <DataGridPro
                rows={tableData}
                columns={columns}
                pageSize={100}
                pagination
                getDetailPanelHeight={getDetailPanelHeight}
                getDetailPanelContent={getDetailPanelContent}
                components={{
                    Toolbar: CustomToolbar,
                }}
            />
        </div>
    )
}

export default AllEntitiesPage;